import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { spring } from "../../utils/motion";
type Tone = "brand" | "accent" | "good" | "ink";
interface ProgressBarProps {
  value: number;
  label: string;
  tone?: Tone;
  size?: "sm" | "md" | "lg";
  className?: string;
}
const toneClass: Record<Tone, string> = {
  brand: "bg-brand",
  accent: "bg-accent",
  good: "bg-good",
  ink: "bg-ink"
};
const heights = {
  sm: "h-2.5",
  md: "h-3.5",
  lg: "h-5"
};
export function ProgressBar({
  value,
  label,
  tone = "brand",
  size = "md",
  className = ""
}: ProgressBarProps) {
  const reduce = useReducedMotion() ?? false;
  const pct = Math.max(0, Math.min(100, value));
  return <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(pct)} className={`overflow-hidden rounded-full border-2 border-line bg-sunken ${heights[size]} ${className}`} data-id="element-1214" data-mp="2mdmo3q30qgy4">
      <motion.div initial={reduce ? false : {
      scaleX: 0
    }} animate={{
      scaleX: pct / 100
    }} transition={spring.smooth} className={`h-full w-full origin-left ${toneClass[tone]}`} data-id="element-1215" data-mp="2w9zjqti4j4vi" />
    </div>;
}